var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "login_FILL0_wght400_GRAD0_opsz48",
    d: "M129.775-822a.724.724,0,0,1-.534-.217.732.732,0,0,1-.216-.538.718.718,0,0,1,.216-.533.732.732,0,0,1,.534-.212H136.5v-15h-6.725a.724.724,0,0,1-.534-.217.732.732,0,0,1-.216-.537.718.718,0,0,1,.216-.533.731.731,0,0,1,.534-.213H136.5a1.439,1.439,0,0,1,1.05.45,1.439,1.439,0,0,1,.45,1.05v15a1.439,1.439,0,0,1-.45,1.05,1.439,1.439,0,0,1-1.05.45Zm-.65-8.25H120.75a.724.724,0,0,1-.534-.217A.732.732,0,0,1,120-831a.718.718,0,0,1,.216-.533.731.731,0,0,1,.534-.212h8.325l-2.025-2.025a.677.677,0,0,1-.213-.525.768.768,0,0,1,.237-.525.734.734,0,0,1,.538-.225.734.734,0,0,1,.537.225l3.325,3.325a.719.719,0,0,1,.225.525.72.72,0,0,1-.225.525l-3.3,3.3a.665.665,0,0,1-.523.213.805.805,0,0,1-.537-.238.75.75,0,0,1-.215-.537.734.734,0,0,1,.225-.538Z",
    transform: "translate(-120 840)",
    fill: "#185edf"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/Login.fd33e303955a4f03ead483f1fe5af5b3.svg";
export { ForwardRef as ReactComponent };